/* eslint-disable @typescript-eslint/no-explicit-any */
import AuthorListingSection from '@apps/containers/AuthorListing';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const AuthorListingScreen = (props: any) => {
  return (
    <>
      <AuthorListingSection {...props} />
    </>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default AuthorListingScreen;
